// extracted by mini-css-extract-plugin
export default {"link":"issue-details_link__IWriy","block":"issue-details_block__f37Qt","block__label":"issue-details_block__label__yl3Tc","block__field":"issue-details_block__field__9y-S7"};